export default {
  key: 'F#',
  suffix: 'sus2sus4',
  positions: [
    {
      frets: '224424',
      fingers: '112314',
      barres: 2
    },
    {
      frets: 'x99b99',
      fingers: '011311',
      barres: 9
    },
    {
      frets: 'x96677',
      fingers: '041122',
      barres: [6, 7]
    },
  ]
};
